module.exports = __webpack_public_path__ + "img/DiNapoli-4.21cb5fe4.jpg";